var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mdetail"},[_c('div',{staticClass:"mdetail_head"},[_c('GlobalLogo'),_c('div',{staticClass:"navlist",on:{"click":_vm.gotonav}},[_c('img',{attrs:{"src":require("../img/mobilenavlist.png")}})])],1),_c('div',{staticClass:"detail_title"},[_vm._v(_vm._s(_vm.deteil_title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }